import { httpBackOfficeUtil } from './httpBackOfficeUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'
import { getData } from '../../utils/common';
export const attachments = {
	uploadFiles,
    addContactAttachment,
    getListAttachments,
}


async function uploadFiles({
    file
} = {}) {
    try {
        let response = await httpBackOfficeUtil.uploadFile({
            resourcePath: "/v1/upload/files",
            fileData: file,
            body:{},
            disalbedContentType: true,
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception uploadFiles: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function addContactAttachment({
    contact_id,
    file_id,
    description
} = {}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: "/v2/contacts/" + contact_id + "/attachments",
            body:{
                file_id,
                description
            },
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception addContactAttachment: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListAttachments({
    contact_id
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: "/v2/contacts/" + contact_id + "/attachments",
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getListAttachments: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}